// Commited Changes 27-06-2025
import { Avatar, Button, Card, Label } from "@fluentui/react-components";
import {
  AddFilled,
  LayerRegular,
  DocumentEditRegular,
  ClipboardTextEditRegular,
  ArrowCircleLeftRegular,
  HomeRegular,
  SettingsRegular,
  Save24Regular,
  TaskListLtr24Regular,
} from "@fluentui/react-icons";
import * as React from "react";
import axios from "axios";
import "./Home.css";
// import '../components/Global/Global.css';
import AlternateClauseAI from "./AlternateClauseAI";
import { useGetSet } from "react-use";
import Settings from "./Settings/Settings";
import EditDraft from "./EditDraft";
import MissingClause from "./MissingClause";
// import * as Office from "office-js";
import Terms from "./Terms";
import SendReview from "./Send Review/SendReview";
import { base64ToBlob, getCurrentWordDocumentAsBase64, readCurrentDocument } from "../Utils/CommonFunctions";
import ContextService from "../services/ContextService";
import RequestRisks from "./RequestRisks";
import ContractTemplate from "./ContractTemplate";
import { SweetAlerts } from "./Global/SweetAlert";
import { Modal, Spinner, SpinnerSize } from "office-ui-fabric-react";
// let FileName = "";
let draftFileName = "";
let ContractId;
interface HomeProps {
  siteURL: string;
  tokenvalue: string;
  currentUser: any;
}
const Home = ({ siteURL }) => {
  //   const dispatch = useDispatch();
  const AiStars : any = require("../../../assets/AiStars.png")
  const [isAlClause, setisAlClause] = React.useState(false);
  const [isHomeOnly, setisHomeOnly] = React.useState(true);
  const [isSettings, setisSettings] = React.useState(false);
  const [isMissingClause, setisMissingClause] = React.useState(false);
  const [isSendReview, setisSendReview] = React.useState(false);
  const [isAISummary, setIsAISummary] = React.useState(false);
  const [isTemporary, setIsTemporary] = useGetSet(false);
  const [isContract, setIsContract] = useGetSet(false);
  const [isRequestRisk, setisRequestRisk] = useGetSet(false);
  const [siteURLVal, setsiteURLVal] = React.useState(siteURL);
  const [isUpdateContractType, setisUpdateContractType] = React.useState(false);
  const [isEditDraft, setisEditDraft] = useGetSet(false);
  const [isTermsOpen,setIsTermsOpen] = React.useState(false);
  const [isTermsDetailsListOpen,setIsTermsDetailsListOpen] = React.useState(false);
  const [isAlterNativeClauseOpen,setIsAlterNativeClauseOpen] = React.useState(false);
  const [isMissingClauseOpen,setIsMissingClauseOpen] = React.useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = React.useState(false)
  const [Update, setUpdate] = React.useState(false)
  const [previousComponent, setPreviousComponent] = React.useState<string | null>(null);
  const {SweetAlert:SweetAlert, SweetPrompt:SweetalertPrompt } = SweetAlerts("#Sweetalert");
  const [ShowAllContract, setShowAllContract] = React.useState(false);
  const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI")||"{}")
  const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}")
  const CurrentUser = JSON.parse(localStorage.getItem('CurrentAppUser'))
  // const [DraftFileName,setDraftFileName] = React.useState("");
  const [show, setShow] = React.useState({
    Terms: false,
    alternat: false,
    missingClause: false,
    summary: false,
    SendReview: false,
    AISummary: false
  });

  React.useEffect(() => {
    Office.onReady(async function (info) {
      if (info.host === Office.HostType.Word) {
        // The Office.js library is ready for use in the Word host
        // console.log("Office is ready!");
        const docUrl = Office.context.document.url;
        // console.log("Document URL:", docUrl);
        if (docUrl) {
          const FileName = docUrl
            .split("/")
            .find((i) => i.startsWith("Guid_"))
            ?.replace("Guid_", ""); //.split("/").pop();
          //  setDraftFileName(FileName)
          localStorage.setItem("DraftFileName", FileName);
          draftFileName = FileName;
          setIsTemporary(docUrl.includes("Temporary Folder"));
          const match = docUrl.match(/Attachments\/(\d+)\//);
          ContractId = match ? { Contract_Type: match[1] } : null;

          const contractTypeRowID=docUrl?.split('/').find(i=>i.startsWith("rowID_"))?.replace("rowID_", ""); 
         const filename = docUrl?.split('/')[docUrl?.split('/').length - 1];
          const TempFileName = docUrl?.split("/")?.pop();
        setIsContract(docUrl.includes("Temporary Contract Type"))
         localStorage.setItem("ContractTypeRowID",contractTypeRowID)
         localStorage.setItem("ContractTypeFileName",filename)
         localStorage.setItem("ContractTemplate",TempFileName)
          const requestGuidMatch = docUrl.match(/RequestGuid_([a-f0-9\-]+)/i);
          const riskIdMatch = docUrl.match(/RiskID_([a-f0-9\-]+)/i);
           const RquestRiskID = docUrl.match(/RequestRisk_([a-f0-9\-]+)/i);

          const requestGuid = requestGuidMatch ? requestGuidMatch[1] : null;
          const riskId = riskIdMatch ? riskIdMatch[1] : null;
          const RquestRiskGUID= RquestRiskID ? RquestRiskID[1] : null;
          setisRequestRisk(riskIdMatch ? true : false||RquestRiskGUID?true:false);
          localStorage.setItem("RequestDraftFileName", requestGuid);
          localStorage.setItem("RiskGUID", riskId);
          localStorage.setItem("RequestRiskGUID", RquestRiskGUID);
          // console.log(requestGuid,riskId,requestGuid,'Risk data home')
        }

        if (isTemporary() && !isRequestRisk()) {
          handleOpenEditDraft();
        } else if (isContract() && !isRequestRisk()) {
          handleOpenUpdateContractType();
        } else if (isRequestRisk()) {
          // console.log("requestList");
        } else {
          handleOpenEditDraft();
          handleOpenUpdateContractType();
        }
      } else {
        console.error("Office host is not Word.");
      }
    });
    // Office.onReady(() => {
    //   const docUrl = Office.context.document.url;
    //    console.log("Document URL:", docUrl);
    //    if (docUrl) {
    //     FileName = docUrl.split("/").pop();
    //     localStorage.setItem("DraftFileName",FileName)
    //     setIsTemporary(docUrl.includes("Temporary Folder"));
    //     const match = docUrl.match(/Attachments\/(\d+)\//)
    //     ContractId = match ? { Contract_Type: match[1] } : null;
    // }

    //   if (isTemporary()) {
    //     handleOpenEditDraft();
    //   } else {
    //     handleOpenUpdateContractType();
    //   }
    //   });
    const siteUrl = localStorage.getItem("SiteURL");
    setsiteURLVal(siteUrl);
  }, []);
  // React.useEffect(() => {
  //   console.log(show, "components to show home");
  // }, [show]);

  function handleHome() {
    setisUpdateContractType(false);
    setisEditDraft(false);
    setisAlClause(false);
    setisSettings(false);
    setisHomeOnly(true);
    setisMissingClause(false);
    setisSendReview(false);
    setIsTermsOpen(false);
  }

  function handleOpenAIClause() {
    setisAlClause(true);
    setisUpdateContractType(false);
    setisEditDraft(false);
    setisHomeOnly(false);
    setisSettings(false);
    setisMissingClause(false);
    setisSendReview(false);
    setIsTermsOpen(false);
  }

  function handleTerms() {
    setIsTermsOpen(true);
    setisAlClause(false);
    setisUpdateContractType(false);
    setisEditDraft(false);
    setisHomeOnly(false);
    setisSettings(false);
    setisMissingClause(false);
    setisSendReview(false);
  }

  function handleOpenMissingClause() {
    setisMissingClause(true);
    setisAlClause(false);
    setisUpdateContractType(false);
    setisEditDraft(false);
    setisHomeOnly(false);
    setisSettings(false);
    setIsTermsOpen(false);
    setisSendReview(false);
  }

  function handleOpenSendReview() {
    setisMissingClause(false);
    setisSendReview(true);
    setisAlClause(false);
    setisUpdateContractType(false);
    setisEditDraft(false);
    setisHomeOnly(false);
    setisSettings(false);
    setIsTermsOpen(false);
  }
  function handleOpenUpdateContractType() {
    setisUpdateContractType(true);
    setisEditDraft(false);
    setisHomeOnly(false);
    setisAlClause(false);
    setisSettings(false);
    setisMissingClause(false);
    setisSendReview(false);
    setIsTermsOpen(false);
  }

  function handleOpenEditDraft() {
    setisEditDraft(true);
    setisUpdateContractType(false);
    setisAlClause(false);
    setisHomeOnly(false);
    setisSettings(false);
    setisMissingClause(false);
    setisSendReview(false);
    setIsTermsOpen(false);
  }

  function handleSettings() {
    setPreviousComponent(
      isUpdateContractType
        ? "updateContract"
        : isEditDraft()
        ? "editDraft"
        : isHomeOnly
        ? "home"
        : isAlClause
        ? "AIClause"
        : isMissingClause
        ? "missingClause"
        : isTermsOpen
        ? "terms"
        : null
    );
    setisUpdateContractType(false);
    setisEditDraft(false);
    setisHomeOnly(false);
    setisAlClause(false);
    setisSettings(true);
    setisMissingClause(false);
    setisSendReview(false);
    setIsTermsOpen(false);
  }

  function handleBack() {
    if (previousComponent === "home") {
      handleHome();
    } else if (previousComponent === "updateContract") {
      handleOpenUpdateContractType();
    } else if (previousComponent === "editDraft") {
      handleOpenEditDraft();
    } else if (previousComponent === "AIClause") {
      handleOpenAIClause();
    } else if (previousComponent === "missingClause") {
      handleOpenMissingClause();
    } else if (previousComponent === "terms") {
      handleTerms();
    }
  }

  function handleBackToEditDraft() {
    setisEditDraft(true);
    setShow({ Terms: false, alternat: false, missingClause: false, summary: false, SendReview: false, AISummary:false });
    setIsTermsDetailsListOpen(false);
    setIsAlterNativeClauseOpen(false);
    setIsMissingClauseOpen(false);
    setisSettings(false);
    setisHomeOnly(false);
    setisAlClause(false);
    setisUpdateContractType(false);
    setisMissingClause(false);
    setisSendReview(false);
    setIsTermsOpen(false);
    setIsSummaryOpen(false);
    setIsAISummary(false);
  }

   const saveFile=async ()=>{
      SweetalertPrompt('warning','Are you sure you want to update the file?').then((result)=>
        {
          if(result.isConfirmed){
            handleSaveContractType()
    }
  }) 
  }
const handleSaveContractType=async()=>{
setUpdate(true)
  try {
        const token = localStorage.getItem("CurrentToken");
    if (!token) {
      throw new Error("Authentication token not found in localStorage.");
    }
          const updateFileName:any=localStorage.getItem('ContractTypeFileName');
          const UpdateFile = updateFileName?.replaceAll(' ','_');
      const ContractTypeRowID=localStorage.getItem('ContractTypeRowID');
        const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        const siteUrl = ContextService.GetUrl();
          const listName = "CLM365Contract_Type";
        // Fetch existing attachments
    const attachmentsUrl = `${siteUrl}/_api/web/lists/getbytitle('${listName}')/items(${ContractTypeRowID})/AttachmentFiles`;
    const { data: existingAttachments } = await axios.get(attachmentsUrl, {
      headers: {
        Accept: "application/json;odata=nometadata",
        Authorization: `Bearer ${token}`,
      },
    });
 
        // Delete existing attachments with the same base name
    const matchingNames = await existingAttachments.value.filter(ele=>ele.FileName===UpdateFile)
     for (const name of matchingNames) {
      const deleteUrl = `${attachmentsUrl}/getByFileName('${name?.FileName}')`;
      await axios.delete(deleteUrl, {
        headers: {
          "IF-MATCH": "*",
          Authorization: `Bearer ${token}`,
        },
      });
    }
 
        // Get the Word document base64
    const base64Doc = await readCurrentDocument();
 
   
 // Upload new file
const uploadUrl = `${attachmentsUrl}/add(FileName='${UpdateFile}')`;
await axios.post(uploadUrl, base64Doc, {
  headers: {
    "Content-Type": mimeType,
    Authorization: `Bearer ${token}`,
  },
});
        // console.log("File uploaded successfully.");
        SweetAlert('success','File updated successfully.')
        setUpdate(false)
  } catch (error) {
        console.error("Error saving contract type file:", error);
        SweetAlert('success','File updated successfully.')
         setUpdate(false)
  }
 
}
  return (
    <>
      <div className="cardMainContainer">
        <div className="BackButtonContainer flexalignSpcBetween">
          <div className="flexalignCenter headerLogoAndLabel">
            {isSettings ? (
              <ArrowCircleLeftRegular onClick={handleBack} title="Back" />
            ) : isUpdateContractType ||
              isSettings ||
              (isEditDraft() &&
                !isTermsDetailsListOpen &&
                !isAlterNativeClauseOpen &&
                !isMissingClauseOpen &&
                !isSummaryOpen &&
                !isAISummary) ? (
              <HomeRegular onClick={() => handleHome()} />
            ) : (isAlClause || isMissingClause || isTermsOpen) && !isEditDraft() ? (
              <ArrowCircleLeftRegular onClick={() => handleOpenUpdateContractType()} title="Home AI " />
            ) : isTermsDetailsListOpen || isMissingClauseOpen || isAlterNativeClauseOpen || isSummaryOpen || isAISummary? (
              <ArrowCircleLeftRegular onClick={() => handleBackToEditDraft()} title="Edit Draft AI " />
            ) : null}
          </div>
          <div className="flexalignCenter SendButtons">
            <div>
               {(!show.Terms && !show.alternat && !show.missingClause && !show.summary &&!show?.SendReview&& isContract())? <div style={{display:'flex', gap:'5px'}}>
                <TaskListLtr24Regular onClick={()=>setShowAllContract(!ShowAllContract)} style={{width:'20px'}}/>
                <Save24Regular style={{width:'20px'}} onClick={() => saveFile()}/> 
                </div>:null}
            </div>
            <div className={"SendButtons"}>
              <SettingsRegular onClick={() => handleSettings()} />
            </div>
          </div>
        </div>

        {/* {!isUpdateContractType && !isEditDraft() && isHomeOnly && (
          <div className="CardDivContainer"
            onClick={isTemporary() ? handleOpenEditDraft : handleOpenUpdateContractType}>
            <div className="ms_card_container">
              <div className="card_icon">{ isTemporary() ? <DocumentEditRegular /> : <ClipboardTextEditRegular />}</div>
              <div className="card_contnet">
                <Label className="card_heading">
                  { isTemporary() ? "Update Draft File" : "Update Contract Type Template"}
                </Label>
                <Label className="card_description">
                  { isTemporary()
                    ? "Revise and finalize the content of the draft file to reflect the latest changes and feedback."
                    : "Revise and standardize contract templates for improved consistency and compliance."}
                </Label>
              </div>
            </div>
          </div>
        )} */}

        {!isUpdateContractType && !isEditDraft() && isHomeOnly && (
          <>
            {!isTemporary() && (
              <div className="CardDivContainer" onClick={handleOpenUpdateContractType}>
                <div className="ms_card_container">
                  <div className="card_icon">
                    <ClipboardTextEditRegular />
                  </div>
                  <div className="card_contnet">
                    <Label className="card_heading">Update Contract Type Template</Label>
                    <Label className="card_description">
                      Revise and standardize contract templates for improved consistency and compliance.
                    </Label>
                  </div>
                </div>
              </div>
            )}
            {!isContract() && !isRequestRisk() && (
              <div className="CardDivContainer" onClick={handleOpenEditDraft}>
                <div className="ms_card_container">
                  <div className="card_icon">
                    <DocumentEditRegular />
                  </div>
                  <div className="card_contnet">
                    <Label className="card_heading">Update Draft File</Label>
                    <Label className="card_description">
                      Revise and finalize the content of the draft file to reflect the latest changes and feedback.
                    </Label>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {(isUpdateContractType && !isEditDraft() && !isHomeOnly)&&(CurrentUser?.userRole === 'Legal Head' || CurrentUser?.userRole === 'Legal User') && (
          <><ContractTemplate ShowAllContract={ShowAllContract}/>
          <>
            <div className="CardDivContainer" onClick={handleTerms}>
              <div className="ms_card_container">
                <div className="card_icon">
                  <LayerRegular />
                </div>
                <div className="card_contnet">
                  <Label className="card_heading">Terms</Label>
                  <Label className="card_description">
                    Select terms from the options provided and insert them into the document.
                  </Label>
                </div>
              </div>
            </div>
            {(CurrentUser?.userRole === 'Legal Head' || CurrentUser?.userRole === 'Legal User')&&
            <>
            <div className="CardDivContainer" onClick={handleOpenAIClause}>
              <div className="ms_card_container">
                <div className="card_icon">
                  <LayerRegular />
                </div>
                <div className="card_contnet">
                  <Label className={`${'card_heading'} ${'ai_card'}`}>Alternative Clauses
                    <img src={AiStars} alt="AI Stars" width={25} height={25} />
                  </Label>
                  <Label className="card_description">
                    Select clause from the contract and use AI to generate an alternative of that clause.
                  </Label>
                </div>
              </div>
            </div>
            {(AzureAI?.Endpoint && AzureAI?.DeploymentName && AzureAI?.APIkey && AzureAI?.AzureOpenAIToggle || Copilot?.CopilotToggle ==='Yes') && <div className="CardDivContainer" onClick={handleOpenMissingClause}>
              <div className="ms_card_container">
                <div className="card_icon">
                  <LayerRegular />
                </div>
                <div className="card_contnet">
                  <Label className={`${'card_heading'} ${'ai_card'}`}>Missing Clauses 
                    <img src={AiStars} alt="AI Stars" width={25} height={25} />
                  </Label>
                  <Label className="card_description">Identify all missing clauses from the contract using AI.</Label>
                </div>
              </div>
            </div>}
            </>}
          </></>
        )}
        {isEditDraft() && (
          <>
            <EditDraft
              setIsTermsDetailsListOpen={setIsTermsDetailsListOpen}
              setShow={setShow}
              show={show}
              setIsAlterNativeClauseOpen={setIsAlterNativeClauseOpen}
              setIsMissingClauseOpen={setIsMissingClauseOpen}
              setIsSummaryOpen={setIsSummaryOpen}
              setIsAISummary={setIsAISummary}
            />
          </>
        )}

        {isAlClause && (
          <>
            <AlternateClauseAI />
          </>
        )}
        {isMissingClause && (
          <>
            <MissingClause />
          </>
        )}
        {isTermsOpen && (
          <>
            <Terms
              requestDetails={ContractId}
              type={"ContractTemp"}
            />
          </>
        )}
        {isSettings && (
          <>
            <Settings isSettings={isSettings} setisSettings={setisSettings} handleHome={handleHome} />
          </>
        )}
        {isSendReview && (
          <>
            <SendReview FileName={draftFileName} RequestListData={null} />
          </>
        )}
        {isRequestRisk() && isHomeOnly && <RequestRisks />}
        {
          <Modal
                    isOpen={Update}
                    onDismiss={()=>setUpdate(false)}
                    styles={{
                      main: {
                        maxWidth: 500,
                        minWidth: 150,
                        padding: "20px",
                        minHeight: "50px",
                      },
                    }}
                  >
                    <Spinner
                      label="Updating your file please wait..."
                      size={SpinnerSize.small}
                      style={{ marginTop: "6%" }}
                    />
                  </Modal>
        }
      </div>
    </>
  );
};

export default Home;
